import { useQueryClient } from "@tanstack/react-query";

export default function useInvalidateManualSizeBiasProducts(shopId: string) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({
      queryKey: [
        "get",
        "/shops/{shopId}/sizing/manual-bias/products",
        { params: { path: { shopId } } },
      ],
    });
  };
}
